// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__QjlWA","rootCenter":"LoadMoreObserver_rootCenter__b1aIo","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2N8D6"};